<template>
  <b-container fluid class="px-0">
    <!-- <esg-report-status-table/> -->
    <esg-base-list name="disclosure-content"
                   ref="disclosure-content-list"
                   title="ESG 공시 보고서 항목"
                   :clickable="true"
                   @rowClicked="showDetail">
      <template #colgroup>
        <col v-for="column in columns"
             :key="column.name"
             :style="{ width: column.width }"/>
      </template>

      <template #cell(disclosure_id)="{ value }">
        <td class="text-center align-middle">
          <span>{{ disclosureName(value) }}</span>
        </td>
      </template>

      <template #cell(status)="{ value }">
        <td class="text-center align-middle">
        <span class="status-tag"
              :class="snakeToPascal(value)">{{ snakeToTitle(value) }}</span>
        </td>
      </template>

      <template #cell(title)="{ value }">
        <td class="text-left align-middle">
          <span>{{ value }}</span>
        </td>
      </template>

      <template #cell(start_date)="{ item }">
        <td class="text-center align-middle">
          <span>{{ formatDate(item.start_date) }}</span>
          <span v-if="item.start_date"
                class="break-after"> ~ </span>
          <span>{{ formatDate(item.due_date) }}</span>
        </td>
      </template>

      <template #cell(assignee)="{ item, value }">
        <td class="text-center">
          <div class="assignee-wrap">
            <!-- Profile image -->
            <span class="user-profile">
              <img src="@/assets/images/icon_user.png"
                   alt="User profile image">
            </span>
            <!-- /Profile image -->

            <!-- Assignee name -->
            <span class="assignee-name"
                  v-b-tooltip.hover
                  :title="value">{{ username(value) }}</span>
            <!-- /Assignee name -->
          </div>
        </td>
      </template>
    </esg-base-list>
  </b-container>
</template>

<script>
import EsgBaseList from "@/components/esg/base/EsgBaseList.vue";

export default {
  name: "EsgDisclosureContentList",
  components: {
    EsgBaseList,
  },
  data() {
    return {
      myValue: 'test',
      columns: [
        {name: 'ID', width: "10%"},
        {name: '보고서', width: "15%"},
        {name: '담당자', width: "8%"},
        {name: '상태', width: "10%"},
        {name: '제목', width: "35%"},
        {name: '시작 ~ 종료일', width: "15%"},
      ],
    }
  },
  computed: {
    users() {
      return this.$store.getters["report/users"];
    },
    disclosures() {
      return this.$store.getters["report/disclosureOptions"];
    },
  },
  async created() {
    await Promise.all([
      this.$store.dispatch('report/retrieveUsers'),
      this.$store.dispatch('report/retrieveDisclosureOptions')
    ]);
  },
  activated() {
    this.$refs['disclosure-content-list'].$refs['table'].initialize();
  },
  methods: {
    username(userId) {
      const user = this.users.find(user => user.userId === userId);
      return user ? user.userName : null;
    },
    disclosureName(disclosureId) {
      const disclosure = this.disclosures.find(disclosure => disclosure.disclosureId === disclosureId);
      return disclosure ? disclosure.name : '-';
    },
    showDetail(item) {
      this.pushRoute({name: "EsgDisclosureContentDetail", params: {id: item.content_id}});
    },
    snakeToPascal(str) {
      return str.toLowerCase().replace(/_/g, "-");
    },
    snakeToTitle(str) {
      return str
          .split('_')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(' ');
    },
    formatDate(datetime) {
      return !datetime ? null : this.$moment(datetime).format("YYYY-MM-DD");
    }
  },
}
</script>

<style scoped>
/* Start - Status column style */
.status-tag {
  display: inline-block;
  max-width: 100px;
  width: 100%;
  height: 29px;
  padding: 4px 6px;
  border-radius: 38px;
  text-align: center;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  white-space: nowrap
}

.status-tag.in-progress {
  background-color: #F5ECD6;
  color: #FF5C00;
}

.status-tag.in-progress-red {
  background-color: #F5D6D6;
  color: #F00;
}

.status-tag.to-do {
  background-color: #F6F6FA;
  color: #2E2E38;
}

.status-tag.done {
  background-color: #CFDDFF;
  color: #1755CC;
}

.status-tag.closed {
  background-color: #D7F5D6;
  color: #168D4C;
}

.status-tag.cancelled {
  background-color: #E4E4EA;
  color: rgba(116, 116, 128, 0.70);
}

.break-after::after {
  content: "";
  display: block;
}

/* End - Status column style */

/* Start - Assignee column style */
.assignee-wrap {
  display: flex;
  align-items: center;
  gap: 0 0.729vw;
  width: 100%;
  white-space: nowrap;
}

.assignee-wrap .user-profile {
  position: relative;
  flex-grow: 1;
  flex-shrink: 0;
  display: inline-block;
  width: 40px;
  height: 40px;
  overflow: hidden;
  border-radius: 50%;
}

.assignee-wrap .user-profile img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  object-fit: cover;
}

.assignee-wrap .assignee-name {
  width: calc(100% - 40px - 0.729vw);
  max-width: 98px;
}

/* End - Assignee column style */
</style>
